import { IndexExpense } from "../../index-expense";
import { responseRemoveExpense } from "../../http/res/response-remove-expense";

export class updateCategoriesAfterRemoveExpense {
    data: IndexExpense;
    res: responseRemoveExpense;
    constructor(data,res){
this.data = data;
this.res = res;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/add-campaign/update-categories-after-remove-expense.ts